export default __webpack_public_path__ + "static/media/56.589875ed.png";